import { useSelector } from 'react-redux';
import NavigationDuck from '../redux/navigation/navigation.duck';
import { Redux } from 'src/redux/redux.interface';

export const useNavigationDuck = () => {
    const navigation = useSelector((state: Redux) => NavigationDuck.getOwnState(state));

    return { navigation };
};
